import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";

import PDFApi from "api/pdfApi";
import BucketApi from "api/bucketApi";
import ProcesosApi from "api/procesosApi";

const RevocarProceso = ({ open, onClose, audienciaId, audiencia: audienciaProp, onSuccess }) => {
  const [error, setError] = useState(undefined);
  const [audiencia, setAudiencia] = useState(null);
  const [newRevocacion, setNewRevocacion] = useState({
    manifestaciones: "",
  });
  const [saving, setSaving] = useState(false);
  const FILE_NAME = "pdf_revocacion.pdf";
  const ANEXO_TYPE = "PDF_REVOCACION";

  const fetchInitialData = async () => {
    try {
      if (audienciaProp) {
        setAudiencia(audienciaProp);
        return;
      }
      const audienciaResp = await ProcesosApi.fetchAudienciaById(audienciaId);
      setAudiencia(audienciaResp.data);
    } catch (error) {
      console.error("Error al obtener los datos iniciales:", error);
      setError(obtenerMensajeError(error, "Error al cargar los datos iniciales."));
    }
  };

  useEffect(() => {
    if (open && (audienciaId || audienciaProp)) {
      fetchInitialData();
    }
  }, [audienciaId, audienciaProp, open]);

  // Actualizar audiencia local cuando cambie la prop
  useEffect(() => {
    if (audienciaProp) {
      setAudiencia(audienciaProp);
    }
  }, [audienciaProp]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    //alert("newRevocacion: " + JSON.stringify(newRevocacion));
    if (newRevocacion.manifestaciones == "") {
      setError("Debes registrar las Manifestaciones de la revocación.");
      return;
    }
    const updatedAudiencia = {
      ...audiencia,
      estado: "CERRADA",
      etapas: audiencia.etapas.map((etapa) =>
        etapa.orden === 2 // CONTROL DE LEGALIDAD
          ? {
              ...etapa,
              estado: "CUMPLIDA",
              resultado: {
                manifestaciones: newRevocacion.manifestaciones,
              },
            }
          : etapa
      ),
    };
    const datosRevocarProceso = {
      operacion: "REVOCAR_PROCESO",
      id_audiencia: audiencia.id,
      manifestaciones: newRevocacion.manifestaciones,
    };
    const confirmacion = window.confirm(`¿Está seguro(a) de que desea revocar el Proceso?`);
    if (!confirmacion) return;
    try {
      setSaving(true);
      await ProcesosApi.actualizarAudiencia(audiencia.id, updatedAudiencia);
      const response = await ProcesosApi.operarAudiencia(datosRevocarProceso);
      if (response.status === 201 && response.data) {
        const anexoResponse = await ProcesosApi.obtenerAnexoProcesoByTipo(audiencia.proceso, {
          tipo_anexo: ANEXO_TYPE,
        });
        const anexo = anexoResponse.data;
        if (anexo != undefined && !anexoResponse.data.error) {
          await ProcesosApi.eliminarAnexoProceso(audiencia.proceso, anexo.id);
        }
        // Generar PDF ACTUALIZACION ACREECNCIAS
        const pdfResponse = await PDFApi.generateDocument("actaRevocacionProceso", audiencia.id);
        const pdfBlob = new Blob([pdfResponse.data], { type: "application/pdf" });
        const formData = new FormData();
        formData.append("file", pdfBlob, FILE_NAME);
        formData.append("file_type", "proceso");
        formData.append("proceso_id", audiencia.proceso_identificador);
        formData.append("registrar_anexo", "true");
        formData.append("tipo_anexo", ANEXO_TYPE);
        formData.append("nombre_anexo", "Acta Revocación");
        await BucketApi.uploadFile(formData);
        alert("El Proceso ha sido revocado correctamente.");
        onSuccess();
      }
    } catch (error) {
      console.error("Error en al Revocar el Proceso:", error);
      alert(obtenerMensajeError(error, "Ocurrió un error al Revocar el Proceso."));
    } finally {
      setSaving(false);
    }
  };

  const hCClose = () => {
    onClose();
  };

  return (
    <>
      {saving && (
        <Backdrop open={true} style={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Dialog open={open} onClose={hCClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <SuiBox mt={1}>
            <strong>
              Revocar el Proceso: {audiencia?.proceso_identificador || "No tiene Proceso"}
            </strong>
          </SuiBox>
        </DialogTitle>
        <DialogContent>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <SuiTypography variant="h6" fontWeight="light">
                Manifestación de la Revocación
              </SuiTypography>
              <SuiInput
                name="manifestaciones"
                multiline
                rows={4}
                value={newRevocacion.manifestaciones}
                onChange={(e) =>
                  setNewRevocacion({ ...newRevocacion, manifestaciones: e.target.value })
                }
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} color="secondary">
            Cancelar
          </SuiButton>
          <SuiButton variant="gradient" buttonColor="dark" onClick={handleSubmit}>
            Revocar
          </SuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

RevocarProceso.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  audienciaId: PropTypes.int,
  audiencia: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default RevocarProceso;
